import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CmsContentMixin extends Vue {
  get page(): any {
    return this.$store.state.content;
  }

  get content(): any {
    if (this.page && this.page.content) {
      return this.page.content.content;
    }
    return undefined;
  }

  get title(): string {
    if (this.content) {
      return this.content.title;
    }
    return '';
  }

  get headerTitle(): string {
    if (this.content) {
      return this.content.header_title;
    }
    return '';
  }

  get headerImage(): string {
    if (this.content) {
      return this.content.header_image;
    }
    return '';
  }

  get introText(): string {
    if (this.content) {
      return this.content.header_text;
    }
    return '';
  }

  get blocks(): any[] {
    if (this.content) {
      return this.content.blocks;
    }
    return [];
  }

  fetchContent() {
    this.$store.dispatch('content/getContent', {
      route: this.$route,
      i18n: this.$i18n,
    });
  }
}
